import { api } from "./client";

export interface EmailStatus {
  source: "own" | "managed" | null; from: string; from_domain: string; own_key_set: boolean; email_from_set: boolean;
  managed_key_set: boolean; domain_ok: boolean; launch_ready: boolean; environment: "preview" | "production";
}
export interface EmailTestResult {
  ok: boolean; source: string | null; from: string; id: string | null; status_code: number | null; error_code: string | null; message: string | null; to: string;
}
export const emailApi = {
  status: () => api.get<EmailStatus>("/admin/settings/email"),
  sendTest: (to: string, code: string) => api.post<EmailTestResult>("/admin/settings/email/test", { to: to || null, code }),
};
